import axios from 'axios';

import { loadingScreenOn, loadingScreenOff } from '../../components/js/loading-screen';
import { delayForLoadingScreen } from '../const';

const Toggles = [
  'send-report',
  'send-reminder',
  'global-cantab',
  'mfa',
  'auto-logout',
  'anonymize-data',
  'report_a_show_birthday_toggle',
  'employee_inactive_password_reset_toggle',
  'employee_failed_login_password_reset_toggle',
];

const ToggleHandlerInit = () => {
  Toggles.forEach((toggle) => {
    const toggleElement = document.querySelector(`#${toggle}`);

    if (toggleElement) {
      toggleElement.addEventListener('change', () => {
        // NOTE: Only for this toggle we have inverted logic - https://github.com/CogSmart/BrainSuite/issues/1598
        if (toggle === 'anonymize-data') {
          toggleElement.checked = !toggleElement.checked;
        }

        loadingScreenOn();
        axios
          .get(toggleElement.dataset.link, { params: { toggle, value: toggleElement.checked } })
          .then(() => window.location.reload())
          .catch(() => {
            toggleElement.checked = !toggleElement.checked;
            setTimeout(loadingScreenOff, delayForLoadingScreen);
          });
      });
    }
  });
};

export default ToggleHandlerInit;
